import axios from "axios";

const actions = {
  async downloadAllCampaignContact(_context, payload) {
    try {
      const response = await this.$api.call(
        "blast_campaign.downloadAllCampaignContact",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async downloadAllCampaign(_context, payload) {
    try {
      const response = await this.$api.call(
        "blast_campaign.downloadAllCampaign",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async downloadAllReport(_context, payload) {
    try {
      const response = await this.$api.call(
        "blast_campaign.downloadAllReport",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async getPresignDocument(_context, payload) {
    try {
      const response = await this.$api.call(
        "blast_campaign.getPresignDocument",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async hitPresignUrl(context, { buffer, url }) {
    try {
      const response = await axios.put(url, buffer);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async addCampaignContact(_context, payload) {
    try {
      const response = await this.$api.call(
        "blast_campaign.addCampaignContact",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async getDocument(context, payload) {
    try {
      const response = await this.$api.call(
        "blast_campaign.getDocument",
        payload,
      );
      const responseData = response.data;

      context.commit("mutationDocument", responseData);
      return response;
    } catch (error) {
      context.commit("mutationDocument", []);
      throw error;
    }
  },

  async listCampaign(context, payload) {
    try {
      const response = await this.$api.call(
        "blast_campaign.listCampaign",
        payload,
      );
      const responseData = response.data;

      if (typeof payload.tab !== "undefined" && payload.tab !== null) {
        context.commit("mutationCampaigns", {
          responseData,
          tab: payload.tab,
        });
      } else {
        context.commit("mutationCampaigns", responseData);
      }

      context.commit("mutationCampaignsMeta", response.meta);

      return response;
    } catch (error) {
      context.commit("mutationCampaigns", []);
      context.commit("mutationCampaignsMeta", {});

      throw error;
    }
  },

  async listCampaignContact(context, payload) {
    try {
      let response = null;

      // reset campaign contactList
      if (payload.isReset === true) {
        context.commit("mutationCampaignContacts", []);
      } else {
        response = await this.$api.call(
          "blast_campaign.listCampaignContact",
          payload,
        );

        const responseData = response.data;

        if (typeof payload.tab !== "undefined" && payload.tab !== null) {
          context.commit("mutationCampaignContacts", {
            responseData,
            tab: payload.tab,
          });
        } else {
          context.commit("mutationCampaignContacts", responseData);
        }

        context.commit("mutationCampaignContactsMeta", response.meta);
      }

      return response;
    } catch (error) {
      context.commit("mutationCampaignContacts", []);
      context.commit("mutationCampaignContactsMeta", {});

      throw error;
    }
  },

  async listTemplate(context, payload) {
    try {
      const response = await this.$api.call(
        "blast_campaign.listTemplate",
        payload,
      );
      const responseData = response.data;

      context.commit("mutationTemplates", responseData);

      return response;
    } catch (error) {
      context.commit("mutationTemplates", []);
      throw error;
    }
  },

  async listReport(context, payload) {
    try {
      const response = await this.$api.call(
        "blast_campaign.listReport",
        payload,
      );
      const responseData = response.data;

      if (typeof payload.tab !== "undefined" && payload.tab !== null) {
        context.commit("mutationReports", {
          responseData,
          tab: payload.tab,
        });
      } else {
        context.commit("mutationReports", responseData);
      }

      context.commit("mutationReportsMeta", response.meta);

      return response;
    } catch (error) {
      context.commit("mutationReports", []);
      context.commit("mutationReportsMeta", {});

      throw error;
    }
  },

  async createBlastCampaign(_context, payload) {
    try {
      const response = await this.$api.call(
        "blast_campaign.createBlastCampaign",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async executeBlastCampaign(_context, payload) {
    try {
      const response = await this.$api.call(
        "blast_campaign.executeBlastCampaign",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },
};

export default actions;
